import { currentAcademicYear } from './classAcademicYear';

/** 대시보드 Todo ↔ 기본 공유 보드(boardId/revision) 브리지 — 네트워크 없이 저장 경로 결정 */

export type TodoNoteShareBridge = {
  boardId: string;
  revision: number;
};

const BRIDGE_VERSION = 'v1';

function cacheScopeKey(noteWorkspaceId: string | null): string {
  return noteWorkspaceId ?? 'account';
}

function storageKey(userId: string, noteWorkspaceId: string | null): string {
  // 학년도가 바뀌면 새 학년도 「기본」보드를 다시 찾도록 학년도를 키에 포함
  return `cp.todoNoteShareBridge.${BRIDGE_VERSION}.${userId}.${cacheScopeKey(noteWorkspaceId)}.${currentAcademicYear()}`;
}

export function loadTodoNoteShareBridge(
  userId: string,
  noteWorkspaceId: string | null
): TodoNoteShareBridge | null {
  if (!userId || typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(storageKey(userId, noteWorkspaceId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<TodoNoteShareBridge> | null;
    if (!parsed || typeof parsed !== 'object') return null;
    const boardId = typeof parsed.boardId === 'string' ? parsed.boardId.trim() : '';
    const revision = typeof parsed.revision === 'number' ? parsed.revision : NaN;
    if (!boardId || !Number.isFinite(revision) || revision < 0) return null;
    return { boardId, revision };
  } catch {
    return null;
  }
}

export function saveTodoNoteShareBridge(
  userId: string,
  noteWorkspaceId: string | null,
  bridge: TodoNoteShareBridge
): void {
  if (!userId || typeof window === 'undefined') return;
  const boardId = bridge.boardId.trim();
  if (!boardId || !Number.isFinite(bridge.revision) || bridge.revision < 0) return;
  try {
    window.localStorage.setItem(
      storageKey(userId, noteWorkspaceId),
      JSON.stringify({ boardId, revision: bridge.revision } satisfies TodoNoteShareBridge)
    );
  } catch {
    // ignore quota/private mode
  }
}
